// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a5ac15b161fa9805e6c6","116":"38d212bf440782f4ccd0","117":"f9398b1293b6e968d2e3","172":"f68adf6e90e862db46e6"}[chunkId] + ".chunk.js";
};